import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

//Material UI Imports
import { Avatar, Box, Card, Chip, Grid, Skeleton, Typography } from '@mui/material';
import StatCard from '../../../components/StatCard';
import { DataGrid } from '@mui/x-data-grid';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import KeyIcon from '@mui/icons-material/Key';
import PersonIcon from '@mui/icons-material/Person';

const VBO = () => {
  const [vbo365Licenses, setvbo365Licenses] = useState([]);
  const [vbo365Users, setvbo365Users] = useState([]);
    const [history, setHistory] = useState([]);
  //   const [o365Licenses, seto365Licenses] = useState([]);
  //   const [o365Users, seto365Users] = useState([]);
  //   const [loadingLicense, setloadingLicense] = useState(false);
  //   const [loadingUser, setLoadingUser] = useState(false);
    
  
        
        const fetchHistory = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/history`);
                setHistory(
                    response.data
                        .filter((vbo) => vbo.entity === "vbo")
                        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                );
            } catch (error) {
                console.error('Error fetching organizations:', error);
            }
        };
      
        

  const fetchO365Licenses = async () => {
    try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/vbo365/licenses`,
          {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
            },
          }
        );
        setvbo365Licenses(response.data);
    } catch (error) {
        console.error('Error fetching organizations:', error);
    }
  };
 
  const fetchO365Users = async () => {
      try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/vbo365/users`,
            {
              headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('token'),
              },
            }
          );
          setvbo365Users(response.data);
      } catch (error) {
          console.error('Error fetching organizations:', error);
      }
  };



  

  useEffect(() => {
    fetchO365Licenses();
    fetchO365Users();
    fetchHistory();

  }, []);


  return (
        <Box>
            <Typography variant="h6" my={1}>Veeam Backup Office 365</Typography>
            <Grid container spacing={3}>
                <Grid item size={{ xs: 12, lg: 4 }}>
                    <StatCard icon={<Avatar sx={{bgcolor:'#d32f2f'}}><KeyIcon/></Avatar>}  bgColor={vbo365Users.filter(license => license.used > license.total).length > 0 && '#ffebee'} borderColor={vbo365Users.filter(license => license.used > license.total).length > 0 && '1px solid #d32f2f'} title={"Licenses surconsommées"} value={vbo365Users.filter(license => license.used > license.total).length} />
                </Grid>
            </Grid>
            <Box sx={{ mt: 4 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Historique des licences
                </Typography>
                <Card>
                    <Box sx={{ height: 400, width: '100%' }}>
                        {/* <MaterialReactTable table={tableLicenseHistory} /> */}
    
                        <DataGrid
                            rows={history
                                .filter((item) => item.entitySubType === "license" || item.logType?.includes('license'))
                                .map((item, idx) => ({
                                    id: item._id || idx,
                                    date: new Date(item.timestamp).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' +
                                        new Date(item.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                                    type: item.entityType === "used" ? "Utilisation" : item.entityType === "total" ? "Total" : item.entityType,
                                    action: item.action === "added" ? "Ajout" : item.action === "removed" ? "Suppression" : item.action,
                                    diff: item.quantityDiff,
                                    before: item.quantityBefore,
                                    after: item.quantityAfter,
                                    org: item.organizationDetails?.name,
                                    license: item.details?.additionalInfo?.licenseName,
                                    user: item.details?.additionalInfo?.userPrincipalName,
                                }))
                            }
                            columns={[
                                { field: 'date', headerName: 'Date', flex: 1 },
                                { field: 'type', headerName: 'Type', flex: 1 },
                                { field: 'action', headerName: 'Action', flex: 1 },
                                {
                                    field: 'diff',
                                    headerName: 'Différence',
                                    flex: 1,
                                    renderCell: (params) => (
                                        <Chip
                                            label={params.value > 0 ? `+${params.value}` : params.value}
                                            color={params.value > 0 ? "success" : "error"}
                                            size="small"
                                        />
                                    )
                                },
                                { field: 'before', headerName: 'Avant', flex: 1 },
                                { field: 'after', headerName: 'Après', flex: 1 },
                                { field: 'org', headerName: 'Organisation', flex: 1 },
                                { field: 'license', headerName: 'Licence', flex: 1 },
                                { field: 'user', headerName: 'Utilisateur', flex: 1 },
                            ]}
                            pageSize={5}
                            rowsPerPageOptions={[5, 10, 25]}
                            disableSelectionOnClick
                            density='compact'
                            sx={{
              fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
              backgroundColor: '#fff',
              color: '#212121',
              border: 'none',
              boxShadow: 1,
    
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#1F6B43',
                color: 'black',
                fontWeight: 'bold',
              },
              '& .MuiDataGrid-row:nth-of-type(even)': {
                backgroundColor: '#F9F9F9',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#F1F8F4',
              },
              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid #E0E0E0',
              },
              '& .MuiDataGrid-footerContainer': {
                backgroundColor: '#FAFAFA',
              },
            }}
    
                        />
                        {/* <MaterialReactTable table={tableLicenseHistory} /> */}
    
                    </Box>
                </Card>
            </Box>
            <Box sx={{ mt: 4 }}>
                <Typography variant="h6" sx={{ mb: 2 }}>
                    Historique des utilisateurs
                </Typography>
                <Card>
                    <Box sx={{ height: 400, width: '100%' }}>
                        {/* <MaterialReactTable table={tableUserHistory} /> */}
    
                        <DataGrid
                            rows={history
                                .filter((item) => item.entitySubType === "user" || item.logType?.includes('user'))
                                .map((item, idx) => ({
                                    id: item._id || idx,
                                    date: new Date(item.timestamp).toLocaleDateString('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' +
                                        new Date(item.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
                                    type: item.entityType === "used" ? "Utilisation" : item.entityType === "total" ? "Total" : item.entityType,
                                    action: item.action === "added" ? "Ajout" : item.action === "removed" ? "Suppression" : item.action,
                                    diff: item.quantityDiff,
                                    before: item.quantityBefore,
                                    after: item.quantityAfter,
                                    org: item.organizationDetails?.name,
                                    license: item.details?.additionalInfo?.licenseName,
                                    user: item.details?.additionalInfo?.name,
                                }))
                            }
                            columns={[
                                { field: 'date', headerName: 'Date', flex: 1 },
                                { field: 'type', headerName: 'Type', flex: 1 },
                                { field: 'action', headerName: 'Action', flex: 1 },
                                {
                                    field: 'diff',
                                    headerName: 'Différence',
                                    flex: 1,
                                    renderCell: (params) => (
                                        <Chip
                                            label={params.value > 0 ? `+${params.value}` : params.value}
                                            color={params.value > 0 ? "success" : "error"}
                                            size="small"
                                        />
                                    )
                                },
                                { field: 'before', headerName: 'Avant', flex: 1 },
                                { field: 'after', headerName: 'Après', flex: 1 },
                                { field: 'org', headerName: 'Organisation', flex: 1 },
                                { field: 'license', headerName: 'Licence', flex: 1 },
                                { field: 'user', headerName: 'Utilisateur', flex: 1 },
                            ]}
                            pageSize={5}
                            rowsPerPageOptions={[5, 10, 25]}
                            disableSelectionOnClick
                            density='compact'
    
                        />
                    </Box>
                </Card>
            </Box>
        </Box>
  );
};

export default VBO;
